export const fr = {
    common: {
        PIN_CODE_LABEL: 'Code PIN',
        USER_NAME_LABEL: 'Nom complet',
        comment: 'Commentaire',
        year: 'Année',
        configuration: 'Configuration',
        cancel: 'Annuler',
        search: 'Rechercher',
        remove: 'Supprimer',
        confirmationDialogTitle:
            'Êtes-vous sûr de vouloir supprimer cet élément ?',
        selectDate: 'Sélectionnez une date',
        select: 'Sélectionner',
        notFound: 'Non trouvé',
        equipmentPickerPlaceholder: 'Objet équipement...',
        searchPlaceholder: 'Rechercher...',
        equipmentTypePickerPlaceholder: "Type d'équipement...",
        equipmentTypePickerTitle: "Sélectionnez le type d'équipement",
        emptyTableMessage: 'Aucune donnée',
        flowPikcerTitle: 'Sélectionnez le flux',
        selectIcon: 'Sélectionner une icône',
        locationPickerTitle: "Sélectionnez l'emplacement",
        locationPlaceholder: 'Emplacement...',
        noSublocations: 'Pas de sous-emplacements',
        locationsTitle: 'Emplacements',
        edit: 'Modifier',
        save: 'Enregistrer',
        added: 'Ajouté',
        updated: 'Mis à jour',
        add: 'Ajouter',
        removed: 'Supprimé',
        reload: 'Recharger',
        confirm: 'Confirmer',
        rollBack: 'Annuler',
        images: 'Images',
        documents: 'Documents',
        download: 'Télécharger',
        saved: 'Sauvegardé',
        date: 'Date',
        hour: 'Heure',
        preview: 'Aperçu',
        data: 'Données',
        attributes: 'Attributs',
        checkList: 'Liste de contrôle',
        name: 'Nom',
        type: 'Type',
        status: 'Statut',
        designation: 'Désignation',
        symbol: 'Symbole',
        serialNumber: 'Numéro de série',
        registryNumber: "Numéro d'enregistrement",
        machineNumber: 'Numéro de machine',
        udtNumber: 'Numéro UDT',
        manufacturedYear: 'Année de fabrication',
        manufacturer: 'Fabricant',
        supplier: 'Fournisseur',
        mainSupplier: 'Fournisseur principal',
        attribute: 'Attribut',
        nameRequired: 'Le nom est requis',
        yearGreaterThan: "L'année doit être supérieure à",
        location: 'Emplacement',
        fieldRequired: 'Ce champ est requis',
        description: 'Description',
        minimumQuantity: 'Quantité minimale',
        optimalQuantity: 'Quantité optimale',
        priority: 'Priorité',
        formatYYYY: 'Format YYYY',
        storageQuantity: 'Quantité en entrepôt',
        quantity: 'Quantité',
        quantityGreaterThan: 'La quantité doit être supérieure à',
        machine: 'Machine',
        tool: 'Outil',
        order: 'Commande',
        required: 'Requis',
        dateFormat: 'Format de date',
        selectDictionary: 'Sélectionner un dictionnaire',
        selectDictionaryValue: 'Sélectionner la valeur du dictionnaire',
        return: 'Retour',
        parameters: 'Paramètres',
        editCategory: 'Modifier la catégorie',
        addCategory: 'Ajouter une nouvelle catégorie',
        changeColor: 'Changer de couleur',
        noColor: 'Pas de couleur',
        shift: 'Quart de travail',
        start: 'Début',
        end: 'Fin',
        shiftSchema: 'Schéma de quart de travail',
        shifts: 'Quarts de travail',
        dictionary: 'Dictionnaire',
        subEntries: 'Sous-entrées',
        key: 'Clé',
        value: 'Valeur',
        moveUp: 'Monter',
        moveDown: 'Descendre',
        addLocation: 'Ajouter un nouvel emplacement',
        editLocation: "Modifier l'emplacement",
        companiesDatabase: 'Base de données des entreprises',
        flows: 'Flux',
        read: 'Lire',
        write: 'Écrire',
        noImage: "Pas d'image",
        email: 'E-mail',
        function: 'Fonction',
        active: 'Actif',
        notActive: 'Non activé',
        disabled: 'Désactivé',
        entryNumber: "Numéro d'entrée",
        issuedDate: "Date d'émission",
        expiresDate: "Date d'expiration",
        move: 'Déplacer',
        separateForm: 'Séparer de',
        separate: 'Séparer',
        warehouse: 'Entrepôt',
        actions: 'Actions',
        putInCurrentLocation: "Mettre à l'emplacement actuel",
        selectLocationFormRightMenu:
            "Sélectionnez l'emplacement depuis le menu de droite",
        showUnassignedItems: 'Afficher les articles non affectés',
        separated: 'Séparé',
        moved: 'Déplacé',
        categories: 'Catégories',
        welcome: 'Bienvenue',
        loginToSignaloCMMS: 'Connectez-vous à Signalo CMMS',
        login: 'Se connecter',
        loginByEmailAndPassword: 'Se connecter par email et mot de passe',
        loginByCode: 'Se connecter par code',
        accessCode: "Code d'accès",
        enterEmail: "Entrez l'email",
        enterPassword: 'Entrez le mot de passe',
        enterCode: 'Entrez le code',
        userNotFound: 'Utilisateur non trouvé',
        userNotActivated: 'Utilisateur non activé',
        userDisabled: 'Utilisateur désactivé',
        wrongPassword: 'Mot de passe incorrect',
        locations: 'Emplacements',
        pageNotFound: 'Page non trouvée',
        group: 'Groupe',
        yes: 'Oui',
        no: 'Non',
        hourlyCost: 'Coût horaire',
        price: 'Prix',
        newEntry: 'Nouvelle entrée',
        predictedFinishTime: 'Heure de fin prévue',
        ok: 'Ok',
        archive: 'Archive',
        costs: 'Coûts',
        companyManagement: "Gestion d'entreprise",
        companyData: "Données de l'entreprise",
        supportedLanguages: 'Langues prises en charge',
        en: 'Anglais',
        pl: 'Polonais',
        es: 'Espagnol',
        de: 'Allemand',
        it: 'Italien',
        fr: 'Français',
        ru: 'Russe',
        uk: 'Ukrainien',
        pt: 'Portugais',
        tr: 'Turc',
        nl: 'Néerlandais',
        sr: 'Serbe',
        defaultLanguage: 'Langue par défaut',
        companyLogo: "Logo de l'entreprise",
        notificationsManagement: 'Gestion des notifications',
        category: 'Catégorie',
        today: "Aujourd'hui",
        month: 'Mois',
        week: 'Semaine',
        day: 'Jour',
        close: 'Fermer',
        show: 'Montrer',
        rollBackFormalConfirmation: "Confirmation formelle d'annulation",
        signUp: "S'inscrire",
        nameSurname: '@:common.USER_NAME_LABEL',
        users_name_label: 'Étiquette du nom complet',
        userNameSurname: 'Nom complet',
        userSurnameName: 'Nom de famille et prénom',
        phone: 'Numéro de téléphone',
        password: 'Mot de passe',
        password_confirmation: 'Confirmer le mot de passe',
        unassignedItems: 'Articles non assignés',
        currency: 'Devise',
        general: 'Général',
        timezone: 'Fuseau horaire',
        users: 'Utilisateurs',
        groups: 'Groupes',
        productionLine: 'Ligne de production',
        part: 'Pièce',
        fittingParts: 'Pièces adaptées',
        workSchema: 'Plan de travail',
        workSchemas: 'Plans de travail',
        holiday: 'Jour férié',
        changePassword: 'Changer le mot de passe',
        showRest: 'Afficher le reste',
        pageNotPermitted: 'Page non autorisée',
        waitingForActivation: "En attente d'activation",
        editGroup: 'Modifier le groupe',
        addGroup: 'Ajouter un groupe',
        reportProblem: 'Signaler un problème',
        describeOccuredIssue: 'Décrire le problème survenu',
        markAllAsRead: 'Marquer tout comme lu',
        unitType: "Type d'unité",
        unit: 'Unité',
        unitPrice: 'Prix ​​unitaire',
        notConfigured: 'Non configuré',
        rowsPerPage: 'Lignes par page',
        rowsOfPage: 'de',
        true: 'Vrai',
        false: 'Faux',
        export: 'Exportation',
        chooseFileFormat: 'Choisir le format de fichier',
        exported: 'Exporté',
        terminals: 'Terminaux',
        terminal: 'Terminal',
        selectEquipment: "Sélectionnez l'équipement",
        futureIssues: 'Problèmes futurs',
        scheduledOn: 'Prévu le',
        planned: 'Prévu',
        notPlanned: 'Non prévu',
        showOpenIssues: 'Afficher les problèmes ouverts',
        pin: 'NIP',
        assignedEquipment: 'Équipement assigné',
        terminalEquipment: 'Équipement terminal',
        detach: 'Détacher',
        attach: 'Attacher',
        dashboardConfig: 'Configuration du tableau de bord',
        addColumn: 'Ajouter une colonne',
        addRow: 'Ajouter une ligne',
        removeRow: 'Supprimer une ligne',
        registerTerminal: 'Enregistrer le terminal',
        issueGeneratesCost: "L'indisponibilité génère des coûts",
        selectColor: 'Sélectionner la couleur',
        belowMinimum: 'En dessous du minimum',
        belowOptimum: "En dessous de l'optimum",
        synchronization: 'Synchronisation',
        synchronizationExport: 'Exportation des pièces en stock',
        synchronizationImport: 'Importation des pièces en stock',
        mapping: 'Cartographie',
        returnTo: 'Retourner à',
        jobStatusses: 'Processus',
        hidden: 'Caché',
        editEvent: "Modifier l'événement",
        threeDays: '3 jours',
        addEvent: 'Ajouter un événement',
        plannedIssues: 'Problèmes planifiés',
        currentService: 'Service actuel',
        searchLocation: "Rechercher l'emplacement",
        all: 'Tous',
        unfinished: 'Inachevé',
        numberOfIssues: 'Quantité de problèmes',
        unknown: 'Inconnu',
        partEntry: 'Pièce (entrée)',
        foundItems: 'Articles trouvés',
        output: 'Sortie',
        copied: 'Copié',
        link: 'Lien',
        authorizationRequired: 'Autorisation requise',
        authorizationRequiredDescriptionUser:
            "Malheureusement, vous n'avez pas d'autorisation suffisante {value}. Demandez à une personne autorisée d'approuver l'action.",
        authorizationRequiredDescriptionTerminal:
            "Utilisez votre code d'accès pour autoriser l'action.",
        showAll: 'Afficher tout',
        showClassicView: 'Afficher la vue classique',
        noIssuesInCategory: 'Aucun problème dans cette catégorie.',
        numberOfIssuesInThisCategoryAndSubcategories:
            'Nombre de problèmes dans cette catégorie et ses sous-catégories.',
        numberOfIssuesInThisCategory:
            'Nombre de problèmes dans cette catégorie.',
        minBarcodeLength: 'Longueur minimale du code-barres',
        currentPage: 'Page actuelle',
        allPages: 'Toutes les pages',
        selectFormat: 'Sélectionner le format',
        provided_currency: 'Devise fournie',
        provided_quantity: 'Quantité fournie',
        provided_unit: 'Unité fournie',
        provided_unit_price: 'Prix ​​unitaire fourni',
        unit_price: 'Prix ​​unitaire',
        quantity_available: 'Quantité disponible',
        editBarcode: 'Modifier le code-barres',
        crews: 'Équipes',
        scheduleEventTypes: "Types d'événements de planification",
        crew: 'Équipe',
        scheduleEvent: 'Événement de planification',
        available: 'Disponible',
        'App\\Models\\Crew': 'Équipe',
        'App\\Models\\User': 'Utilisateur',
        'App\\Models\\Equipment': 'Équipement',
        'App\\Models\\Part': 'Partie',
        Crew: 'Équipe',
        User: 'Utilisateur',
        Equipment: 'Équipement',
        Part: 'Partie',
        scheduleEvents: 'Événements de planification',
        event: 'Événement',
        externalSystems: 'Systèmes externes',
        user: 'Utilisateur',
        availability: 'Disponibilité',
        inheritColorFromParentIfCustomNotSet:
            "Hériter de la couleur du parent si la couleur personnalisée n'est pas définie",
        pickFromAllParts: 'Choisir parmi toutes les pièces',
        takeTool: "Prendre l'outil",
        returnTool: "Rendre l'outil",
        personWhoTake: 'Personne qui prend',
        personWhoReturn: 'Personne qui rend',
        takenAt: 'Pris à',
        takenBy: 'Pris par',
        toolIssuedBy: 'Outil émis par',
        commentTake: 'Commentaire de prise',
        commentReturn: 'Commentaire de retour',
        change: 'Changer',
        onlyWithActiveRMIssues: 'Uniquement avec les demandes RM actives',
        externalSystem: 'Système externe',
        rejectIssue: 'Rejeter le problème',
        withdrawIssueRejection: 'Retirer le rejet du problème',
        rejectionReason: 'Raison du rejet',
        rejected: 'Rejeté',
        showCrewMembers: "Afficher les membres de l'équipe",
        crewMembers: "Membres de l'équipe",
        helpGroup: 'Service',
        partsTakenByUser: "Pièces prises par l'utilisateur",
        pickParts: 'Pièces de départ',
        selectPersonWhoTakes: 'Sélectionner la personne qui prend',
        changePersonWhoTakes: 'Modifier la personne qui prend',
        quantityToPick: 'Quantité à prendre',
        pickLocation: 'Emplacement de prise en charge',
        selectPartsToPick: 'Sélectionner les pièces à prendre',
        partSelected: 'Pièce sélectionnée',
        scanCodeOr: 'Numériser le code ou',
        returnPart: 'Rendre la pièce',
        myTakenParts: 'Pièces prises par moi',
        takenFromLocation: "Prise à partir de l'emplacement",
        takenQuantity: 'Quantité prise',
        providedUnit: 'Unité fournie',
        providedQuantity: 'Quantité fournie',
        selectFromStorage: 'Sélectionner à partir du stockage',
        selectFromMyPickedParts: 'Sélectionner à partir de mes pièces prises',
        exportProcessInProgressMessage:
            "Le processus d'exportation de données vient de démarrer, lorsqu'il sera terminé, vous verrez une notification correspondante contenant un lien vers le fichier.",
        yourDocumentIsReady: 'Votre document est prêt',
        rotateScreen: "Faire pivoter l'écran",
        addRule: 'Ajouter une règle',
        editRule: 'Modifier la règle',
        summary: 'Résumé',
        onlyAvailableEmployees: 'Afficher uniquement les employés disponibles',
        calculated_unit_price: 'Prix unitaire converti',
        calculated_quantity: 'Quantité convertie',
        next: 'Suivant',
        maintenanceMode: 'Mode de maintenance',
        applicationMayBeUnavailableForFewMinutes:
            "L'application peut être indisponible pendant quelques minutes",
        appWillRefreshIn: "L'application sera actualisée dans",
        landscape: 'Paysage',
        portrait: 'Portrait',
        orientation: 'Orientation',
        format: 'Format',
        service: 'Domestiques',
        leader: 'Contremaîtres',
        defaultView: 'Affichage par défaut',
        view: 'Vue',
        oneDay: '1 jour',
        object: 'Objet',
        finished: 'Terminé',
        onlyNotFinished: 'Seulement pas fini',
        generate: 'Générer',
        error: 'Error',
        cell: 'Celda',
        resolutionSummary: 'Résumé de fin',
        rejected_at: 'Date de rejet',
        rejected_by: 'Rejeté par',
        finishedByUser: 'Terminé par',
        formalConfirmByUser: 'Confirmation formelle par',
        formalConfirmAt: 'Date de confirmation formelle',
        valueDeleted: '[Valeur supprimée]',
        hasNotPlannedIssue: "N'a pas prévu de problèmes",
        showInStorage: 'Afficher dans le stockage',
        changeCode: 'Changer le code',
        staffProfiles: 'Profils des employés',
        profile: 'Profil',
        user_bug: "Erreur d'application",
        user_kaizen: 'Suggestion de changement',
        changeSuggestions: 'Suggestions de modification',
        showOnlyCurrentlyAvailable:
            'Afficher uniquement actuellement disponible',
        resetPassword: 'Rappeler le mot de passe',
        forgotPassword: 'Mot de passe oublié',
        resetPasswordMailSent:
            "Nous avons envoyé un lien pour définir un nouveau mot de passe à l'adresse e-mail fournie",
        manyEventsThisTime: 'De nombreux événements en ce moment',
        importScheduleCheckboxLabel:
            'Supprimer les événements planifiés du mois sélectionné pour les employés répertoriés dans le fichier',
        inheritedEvent: 'Événement hérité',
        inheritedModifiedEvent: 'Événement hérité modifié',
        equipmentId: "ID de l'équipement",
        entryId: "ID d'entrée",
        partId: 'ID de la pièce',
        suggestionsEmail:
            'E-mail à laquelle les suggestions de modification seront envoyées',
        meters: 'Compteurs',
        scanCardToAuth:
            "Présentez la carte au lecteur ou saisissez votre code d'accès pour confirmer votre identité.",
        scanCard: 'Scannez la carte',
        cart: "Boîte d'échange",
        emptyCardMessage:
            'Lancez la numérisation des produits ou sélectionnez-les dans la liste pour les ajouter au panier.',
        terminalMode: 'type de borne',
        askPermittedUserToConfirmPartsExchange:
            'Demandez à la personne autorisée de confirmer la libération de la pièce en scannant la carte ou en saisissant le code.',
        partsIssued: 'Pièces libérées',
        areYouSureAboutCancel: 'Êtes-vous sûr de vouloir annuler?',
        areYouSureAboutRemoveFromCart:
            "Êtes-vous sûr de vouloir supprimer cet article du Boîte d'échange?",
        standard: 'Standard',
        idNumber: "Numéro d'identification",
        takeParts: 'Prendre des pièces',
        returnParts: 'Rendre des pièces',
        quantityToReturn: 'Quantité à rendre',
        partsPendingApproval: "Pièces en attente d'approbation",
        partsReturned: 'Pièces rendues',
        partsAddedToPendingApproval:
            "Pièces ajoutées à l'approbation en attente",
        approvePartsReturn: 'Approuver le retour de pièces',
        partReturnApproved: 'Retour de pièce approuvé',
        partUsage: 'Utilisation de la pièce',
        awaitsReturn: 'En attente de retour',
        entrySelection: "Sélection d'entrée",
        correctQuantity: 'Quantité correcte',
        quantityCorrection: 'Correction de la quantité',
        entrySelectionAsc: "Sélection d'entrée (ascendant)",
        entrySelectionDesc: "Sélection d'entrée (descendant)",
        metersSettings: 'Paramètres des compteurs',
        countableFields: 'Champs comptables',
        equipmentTypes: "Types d'équipement",
        fieldName: 'Nom du champ',
        countableField: 'Champ comptable',
        partsStatusTaken: 'Pièces prises',
        rejectPartsReturn: 'Rejeter le retour de pièces',
        areYouSureAboutRejectPartsReturn:
            'Êtes-vous sûr de vouloir rejeter le retour de pièces?',
        partReturnRejected: 'Retour de pièce rejeté',
        counterFields: 'Champs de compteur',
        counterName: 'Nom du compteur',
        counterFieldName: 'Nom du champ de compteur',
        counterId: 'ID du compteur',
        counterUUID: 'UUID du compteur',
        counterPickerPlaceholder: 'Sélectionnez un compteur',
        pickFromPartsList: 'Choisir dans la liste des pièces',
        changeLocation: "Changer l'emplacement",
        isPartStorageRoot: 'Racine du stockage de pièces',
        isStorageRoot: 'Racine du stockage de pièces',
        areYouSureAboutArchiveIssue:
            'Êtes-vous sûr de vouloir archiver cette question?',
        ganttChart: 'Diagramme de Gantt',
        table: 'Tableau',
        fittingEquipment: 'Équipement de montage',
        notAssigned: 'Non assigné',
        counters: 'Compteurs',
        machineHourlyCostNotProvided:
            "Le coût horaire de la machine n'est pas fourni",
        eventTypesMightBeDefinedHere:
            "Les types d'événements peuvent être définis ici",
        toolsTakenByUser: "Outils pris par l'utilisateur",
        predictedReturnDate: 'Date de retour prévue',
        estimatedTimeOfUsingToolInHours:
            "Temps estimé d'utilisation de l'outil (en heures)",
        showOnlyAvailable: 'Afficher uniquement disponible',
        toolTakeLog: "Journal de prise d'outil",
        takeDate: 'Date de prise',
        returnDate: 'Date de retour',
        personWhoAcceptReturn: 'Personne qui accepte le retour',
        statisticStrategy: "Stratégie d'accessibilité",
        EquipmentPlannedStrategy: 'Selon le plan de travail',
        EquipmentConstantAvailabilityStrategy: 'Toujours disponible',
        actionAfterIssueFinish: 'Action après la fin de la question',
        enabled: 'Activé',
        categoryOfNewIssue: 'Catégorie de nouvelle question',
        workNotStarted: 'Travail non commencé',
        colorInherited: 'Couleur héritée',
        abcClassification: 'Classification ABC',
        xyzClassification: 'Classification XYZ',
        classification: 'Classification',
        filters: 'Filtres',
        wipeFilters: 'Effacer les filtres',
        takePartsFromUser: "Prendre des pièces à l'utilisateur",
        selectPersonWhoReturns: 'Sélectionnez la personne qui retourne',
        changePersonWhoReturns: 'Changer la personne qui retourne',
        returnLocation: 'Emplacement de retour',
        returnQuantity: 'Quantité de retour',
        globalSettings: 'Paramètres globaux',
        delimiter: 'Délimiteur',
        fieldRules: 'Règles de champ',
        fieldValue: 'Valeur du champ',
        user_email_regex: "Regex de l'e-mail de l'utilisateur",
        barcodeLength: 'Longueur du code à barres',
        partLine: 'Ligne de pièce',
        partFamily: 'Famille de pièces',
        partBatch: 'Lot de pièces (batch)',
        testValueValid: 'Valeur test valide',
        testValueNotValid: 'Valeur de test non valide',
        canBePicked: 'Peut être choisi',
        issue_criticality: 'Problèmes - criticité',
        issue_help_webapp: 'Problèmes : assistance requise (application)',
        issue_help_terminal: 'Problèmes - assistance nécessaire (Terminal)',
        issue_kind: 'Type de signalement',
        HIDE: 'Cacher',
        SHOW: 'Montrer',
        REQUIRE: 'Exiger',
        propagateValues: 'Propagation de la valeur',
        archived: 'Archivé',
        singleEvent: 'Entrée unique',
        seriesOfEvents: "Une série d'entrées",
        omitWeekends: 'Évitez les week-ends',
        allEntriesSaved: 'Toutes les entrées ont été ajoutées',
        parentCategory: 'Catégorie Parentale',
        first_day_of_week: 'Premier jour de la semaine',
        assignEmployee: 'Affecter un employé',
        addNewMachine: 'Ajouter une nouvelle machine',
        addNewTool: 'Ajouter un nouvel outil',
        parentLocation: 'Localisation des parents',
        equipmentStates: "états de l'équipement",
        equipmentState: "état de l'équipement",
        fontColor: 'couleur de la police',
        downtime: "Temps d'arrêt",
        setState: "Définir l'état",
        from: 'depuis',
        to: 'à',
        inProgress: 'en cours',
        noEntries: 'aucune entrée',
        products: 'des produits',
        product: 'produit',
        setCurrentProduct: 'Définir le produit actuellement en production',
        commentable: 'Possibilité de commenter',
        allows_state_update: "Changement d'état requis lors du commentaire",
        undescribed: 'Indescriptible',
        state: 'Condition',
        productionMonitor: 'Moniteur de production',
        undescribedStates: 'États non décrits',
        toolsPicker: 'Prendre / rendre les outils',
        toolsGroups: "Groupes d'outils",
        of: 'de',
        image: 'Photo',
        selectTools: 'Choisir des outils',
        takeTools: 'Télécharger des outils',
        returnTools: 'Rendre les outils',
        askPermittedUserToConfirmToolsExchange:
            'Demandez à la personne autorisée de confirmer la délivrance/retour des outils en scannant la carte ou en saisissant le code.',
        toolsPendingApproval: "Outils retournés en attente d'approbation",
        production_monitor_visible_columns:
            'Moniteur de production - colonnes visibles',
        details: 'Détails',
        otherData: 'Autre informations',
        showAllTools: 'Afficher tous les outils',
        allTools: 'Tous les outils',
        approveToolReturn: "Accepter le retour de l'outil",
        rejectToolReturn: "Refuser le retour de l'outil",
        areYouSureAboutRejectToolReturn:
            "Etes-vous sûr de vouloir refuser le retour de l'outil ?",
        areYouSureAboutAcceptToolReturn:
            "Etes-vous sûr de vouloir confirmer le retour de l'outil ?",
        toolReturnApproved: "Retour d'outil approuvé",
        toolReturnRejected: "Retour d'outil refusé",
        toReturn: 'Rendre',
        toolsCart: "Boîte d'échange - outils",
        toolsIssued: 'Outils téléchargés',
        toolsAddedToPendingApproval:
            "Les outils ont été ajoutés à la liste d'attente d'approbation de retour",
        toolsReturned: 'Outils retournés',
        mainShift: 'Changement principal',
        scanCode: 'Scannez le code',
        codeRecognized: 'Code reconnu',
        moveAllEntriesFromCurrentLocation:
            'Déplacer toutes les entrées de cet emplacement',
        newAwaitingValue: "Nouvelle valeur en attente d'approbation",
        newValuesArePendingConfirmation:
            "Les changements sont en attente d'approbation",
        changeRequests: 'Demandes de changement',
        currentValues: 'Valeurs actuelles',
        requestedValues: 'Des valeurs à changer',
        removeRequestIsWaitingForApprove:
            "La suppression est en attente d'approbation",
        imageRemoveRequestLabel: 'Supprimer une photo',
        areYouSureAboutCancelChangeRequest:
            'Êtes-vous sûr de vouloir annuler la demande de modification ?',
        document: 'Document',
        rename: 'Renommer',
        openInEditor: "Ouvrir dans l'éditeur",
        unsavedChangesMayBeLost:
            'Les modifications non enregistrées peuvent être perdues',
        location_name_regex: "Règle de nom d'emplacement",
        employeesWorkingCount: "Nombre d'employés travaillant sur ce sujet",
        always: 'Toujours',
        indexes: 'Index',
        indexesEntriesTypes: "Types d'entrée",
        indexEntry: "Entrée d'index",
        index: 'Indice',
        pickIndex: 'Sélectionnez un index',
        report: 'Rapport',
        reportGenerationInProgress: 'Le rapport génère',
        production_monitor_equipment_state_change:
            "Modification de l'état de la machine depuis le moniteur de production",
        part_entries_auto_barcode_generation:
            'Génération automatique de codes-barres pour les entrées de pièces',
        new_issue_equipment_kind:
            "Type d'équipement dans la nouvelle notification",
        manageVisibleColumns: 'Ajuster la visibilité des colonnes',
        columnName: 'Nom de colonne',
        visible: 'Visible',
        partStorageRootWarningMessage:
            "Cet emplacement sera défini comme emplacement principal de l'entrepôt de pièces, l'entrepôt et la fenêtre de sélection de l'emplacement de l'entrepôt vous permettront uniquement de sélectionner les entrées situées à cet emplacement.",
        entriesLocation: 'emplacement des entrées',
        cloneIssue: 'Cloner',
        machinesMap: 'Plan des machines',
        doYouWantToAddNewMarker:
            'Souhaitez-vous ajouter une nouvelle balise ici ?',
        areYouSureAboutRemoveMarker:
            'Êtes-vous sûr de vouloir supprimer cette balise ?',
        plants: "Usines d'usine",
        plant: 'Usine',
        buildings: 'Bâtiments',
        building: 'Bâtiment',
        floors: 'Sols',
        floor: 'Sol',
        map: 'Carte',
        areYouSureAboutMoveMarker:
            'Êtes-vous sûr de vouloir déplacer ce marqueur ?',
        marker: 'Marqueur',
        addNewMarkerTooltipMessage:
            'Pour ajouter un nouveau marqueur, faites un clic droit sur la carte.',
        takenTools: 'Outils téléchargés',
        askPermittedUserToConfirmToolExchange:
            "Demandez à la personne autorisée de confirmer l'émission/le retour de l'outil en scannant la carte ou en saisissant le code.",
        warnDays: 'Alerte avant expiration (jours)',
        licenseType: 'Type de licence',
        licenseGroup: 'Groupe de licences',
        toolsCartTerminalRequireApproveOnToolReturn:
            'Exiger une confirmation / rejet au retour des outils téléchargés',
        attachments: 'Pièces jointes',
        attachment: 'Pièce jointe',
        searchInCurrentLocation: 'Rechercher dans votre emplacement actuel',
        icon: 'Icône',
        nfc: 'NFC',
        rfid: 'RFID',
        other: 'autre',
        tags: 'Cartes / Mots clés',
        tag: 'Carte / Étiqueter',
        userPinCode: "Code PIN de l'utilisateur de la carte",
        pin_code_field_type: 'Type de code PIN',
        alphanumeric: 'Alphanumérique',
        numeric: 'Numérique',
        showCodeOwnerNameDuringParing:
            "Afficher le nom du propriétaire du code lors de l'association avec une carte/étiquette",
        showUsernameInCart: "Afficher le nom d'utilisateur dans le panier",
        flag: 'Drapeau',
        flags: 'Drapeaux',
        manageFlags: 'Gérer les drapeaux',
        skills: 'Compétences',
        skill: 'Compétence',
        skillRank: 'Notation',
        selectToolsByType: 'Sélectionner les outils par type',
        openToolsPickerOnCartInit:
            'Ouvrez automatiquement la fenêtre de sélection des outils lorsque vous accédez au panier.',
        toolsTypes: "Types d'outils",
        workOrderTemplates: 'Modèles de bons de travail',
        workOrderTemplate: 'Modèle de bon de travail',
        workOrders: 'Bons de travail',
        workOrder: 'Demande de service',
        employee: 'Employé',
        workOrderCreatedBy: 'Commandée par',
        print: 'Imprimer',
        issueCreated: 'Un ticket a été créé',
        newIssue: 'Nouveau rapport',
        sampleButtonPlaceholder: 'Exemple de bouton',
        preferences: 'Préférences',
        buttonsSize: 'Taille du bouton',
        defaultValue: 'Valeur par défaut',
        warning: 'Avertissement',
        allowedIssuesCategories: 'Catégories de problèmes autorisés',
        hideAbilityToAssignEmployeesToIssue:
            "Masquer la possibilité d'affecter des employés à un problème",
        issuesWithRelatedCategories: 'Inclure des sous-catégories',
        issuesLimit: 'Limite des problèmes',
        issuesLimits: 'Enjeux - limites',
        closeLocker: 'Fermez le placard',
        closeLockerMessage: 'Pour continuer, fermez le placard',
        closedTooFast: 'Vous avez fermé trop vite ?',
        doYouWantToReopenLocker: 'Voulez-vous rouvrir le casier ?',
        reopen: 'Rouvrir',
        quit: 'Finition',
        hiddenFields: 'Champs masqués',
        defaultValues: 'Les valeurs par défaut',
        paddingBottom: 'Espace vide en bas',
        allVisibleFieldsRequired:
            'Exiger que tous les champs visibles soient remplis',
        emailConfirmation: "Confirmation de l'adresse e-mail",
        user_active_after_email_confirm:
            'Compte utilisateur automatiquement activé après confirmation de votre adresse email',
        phone_change_requires_confirmation_code:
            'Le changement de numéro de téléphone nécessite une confirmation avec un code',
        toolsLocation: 'Emplacement de l`outil',
        manageFilters: 'Gérer les filtres',
        erase: 'effacer',
        can_pick_undescribed_equipment_state:
            'Possibilité de choisir un état indescriptible',
        helpdesk: "Bureau d'aide",
        measureTypes: 'Types de mesures',
        measureType: 'Type de mesure',
        measurable: 'Indicateur mesurable',
        measurables: 'Indicateurs mesurables',
        measurements: 'La mesure',
        measurement: 'La mesure',
        measuredAt: 'Date de mesure',
        employeeNumber: "Numéro d'employé",
        lastLocation: 'Dernier lieu',
        readonly: 'Lecture seulement',
        equipment: 'Équipement',
        conditions: 'Conditions',
        permission: 'Autorisation',
        formula: 'Formule',
        notification: 'Notification',
        transition: 'Transition',
        fillValuesToChangeState:
            'Complétez les valeurs pour changer le statut.',
        loginTo: 'Se connecter à',
        appName: 'Signalo CMMS',
        manageState: "Gérer l'état",
        webMessage: 'Message Web',
        terminalId: 'Identifiant du terminal',
        operatorId: "Identifiant de l'opérateur",
        newConversation: 'Nouveau fil de discussion',
        application: 'App',
        phones: 'Numeri di telefono',
        message: 'Messaggio',
        channels: 'Canaux',
        url: 'URL',
        kind: 'Gentil',
        forkfleetConfigId: 'Configuration Forkfleet',
        create: 'Créer',
        terminate: 'Mettre fin',
        recreateIssue: 'Recréer le ticket',
        ordinal: 'Valeur ordinale',
        parameterName: 'Le nom du paramètre',
        backgroundColor: "Couleur de l'arrière plan",
        columns: 'Le nombre de colonnes',
        colspan: 'Largeur (colonnes)',
        fill: 'Complet',
        duplicate: 'Dupliquer',
        loginAsThisUser: "Connectez-vous en tant qu'utilisateur",
        partLot: 'Série',
        minBrowserVersion: 'Version minimale du navigateur requise',
        currentVersion: 'Version actuelle',
        equipment_planned_completed_percent_target:
            'Objectif de pourcentage pour la mise en œuvre des inspections planifiées',
        autoTranslate: 'Traduction automatique',
        auto_translation: 'Traduction automatique',
        awaitingAutoTranslation: 'En attente de traduction automatique',
        signaturePinTagConfirmationText1:
            'Signer avec le @:common.PIN_CODE_LABEL',
        signaturePinTagConfirmationText2: 'ou scannez votre carte.',
        signedWithPinCode: 'Signé avec @:common.PIN_CODE_LABEL',
        signedWithTAG: 'Signé avec carte/étiquette',
        trusted_device_code_login_users_limit:
            "Connexion rapide - nombre d'utilisateurs affichés",
        display_fields_issue_created_at:
            "Afficher les champs - Création d'un rapport",
        docs_sidebar_hidden_by_default:
            'Documents - masquer la barre latérale par défaut',
        issue: 'Signalement',
        control: 'Contrôle',
        compatibility: 'Compatibilité',
        replacement: 'Remplacement',
        backCompatibility: 'Compatibilité bidirectionnelle',
    },
    placeholders: {
        part: 'Sélectionner une pièce...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Numéro de téléphone...',
        password: 'Mot de passe...',
        password_confirmation: 'Confirmer le mot de passe...',
        email: 'E-mail...',
    },
    auth: {
        notYourAccountQuestion: 'Pas votre compte?',
    },
    signup: {
        registered: 'Succès!',
        emailConfirmed: "L'e-mail a été confirmé.",
        registered_info: "Demande à ton superviseur d'activer ton compte",
        confirmEmailAddress:
            'Votre compte a été créé, cliquez sur le lien dans l`e-mail pour confirmer votre adresse.',
        tokenNotFoundError:
            "L'e-mail a déjà été confirmé ou le lien de confirmation n'est pas valide.",
    },
    paramTypes: {
        text: 'Texte',
        note: 'Note',
        integer: 'Entier',
        decimal: 'Décimal',
        date: 'Date',
        time: 'Heure',
        datetime: 'Date et heure',
        color: 'Couleur',
        icon: 'Icône',
        boolean: 'Non / Oui',
        signature: 'Signature',
    },
    tableHeaders: {
        id: 'ID',
        name: 'Nom',
        path: "Chemin d'accès au fichier",
        category: 'Catégorie',
        equipment: 'Équipement',
        criticality: 'Criticité',
        status: 'Statut',
        created: 'Créé',
        createdBy: 'Créé par',
        fp: 'FP',
        type: 'Type',
        designation: 'Désignation',
        symbol: 'Symbole',
        serialNumber: 'Numéro de série',
        registryNumber: "Numéro d'enregistrement",
        udtNumber: 'Numéro UDT',
        manufacturedYear: 'Année de fabrication',
        actions: 'Actions',
        title: 'Titre',
        data: 'Date',
        archived: 'Archivé',
        manufacturerSymbol: 'Symbole du fabricant',
        min: 'Min',
        opt: 'Opt',
        quantity: 'Quantité',
        priority: 'Priorité',
        price: 'Prix',
        kind: 'Type',
        description: 'Description',
        default: 'Défaut',
        warning: 'Avertissement',
        problem: 'Problème',
        fixing: 'Résolution',
        changeOrder: 'Ordre de modification',
        required: 'Requis',
        icon: 'Icône',
        color: 'Couleur',
        subCategories: 'Sous-catégories',
        barCode: 'Code barre',
        subLocations: 'Sous-emplacements',
        categories: 'Catégories',
        image: 'Image',
        nameSurname: '@:common.USER_NAME_LABEL',
        email: 'Email',
        phone: 'Numéro de téléphone',
        function: 'Fonction',
        department: 'Département',
        accountStatus: 'Statut du compte',
        shift: 'Quart de travail',
        licenseNumber: 'Numéro de licence',
        issuedDate: "Date d'émission",
        expiresDate: "Date d'expiration",
        entries: 'Entrées',
        entryNumber: "Numéro d'entrée",
        buyPrice: "Prix d'achat",
        currentLocationQuantity: "Quantité à l'emplacement actuel",
        group: 'Groupe',
        string: 'Texte',
        integer: 'Entier',
        toolsGroup: "Groupe d'outils",
        manufacturer: 'Fabricant',
        shortName: 'Nom court',
        locationName: "Nom de l'emplacement",
        subLocationsQuantity: 'Quantité de sous-emplacements',
        isWorkingOnIssue: 'Travaille sur un problème',
        openIssues: 'Problèmes ouverts',
        notificationDate: 'Date de notification',
        titleAndDescription: 'Titre et description',
        read: 'Lu',
        created_at: 'Créé',
        received_at: 'Reçu',
        started_at: 'Pris',
        arrived_at: 'Arrivé',
        finished_at: 'Terminé',
        country: 'Pays',
        city: 'Ville',
        progress: 'Progression',
    },
    searchConfig: {
        id: 'Id',
        name: 'Nom...',
        shortName: 'Nom court...',
        country: 'Pays...',
        email: 'Email...',
        group: 'Groupe...',
        planned: 'Prévu',
        category: 'Catégorie...',
        object: 'Objet...',
        criticality: 'Criticité',
        fp: 'FP',
        type: 'Type...',
        designation: 'Désignation...',
        symbol: 'Symbole...',
        serialNumber: 'Numéro de série...',
        registryNumber: "Numéro d'enregistrement...",
        udtNumber: 'Numéro UDT...',
        manufacturedYear: 'Année de fabrication...',
        manufacturerSymbol: 'Symbole du fabricant...',
        priority: 'Priorité...',
        quantity: 'Quantité...',
        buyPrice: "Prix d'achat...",
        kind: 'Type...',
        toolsGroup: "Groupe d'outils...",
        function: 'Fonction...',
        department: 'Département...',
        status: 'Statut...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Téléphone...',
        barCode: 'Code barre',
        color: 'Couleur...',
        icon: 'Icône...',
        machine: 'Machine...',
        tool: 'Outil...',
        urgentAndOutdated: 'Urgent et obsolète',
        urgent: 'Urgent',
        expired: 'Expiré',
        manufacturer: 'Fabricant',
    },
    errors: {
        error: "Une erreur s'est produite",
        wrongEmail: 'Adresse email non valide',
        wrongPasswordLength:
            'Le mot de passe doit avoir au moins 8 caractères.',
        wrongCodeLength: 'Le code doit avoir au moins 5 caractères.',
        passwordsNotMatch: 'Les mots de passe ne correspondent pas',
        codesNotMatch: 'Les codes ne correspondent pas',
        codeAlreadyInUse: 'Code déjà utilisé',
        expiresDateLowerThanIssued:
            "La date d'expiration ne peut pas être inférieure à la date d'émission.",
        cannotMoveToTheSameLocation:
            'Impossible de déplacer vers la même emplacement.',
        locationRequired: "L'emplacement est requis.",
        putQuantity: 'Indiquez la quantité à séparer.',
        valueGreaterThanQuantity:
            'La valeur est supérieure à la quantité totale.',
        wholeCannotBeDistinguished: "L'ensemble ne peut pas être distingué.",
        yearMustBeGreaterThan: "L'année doit être supérieure à ",
        passwordConfirmationNotMatch: 'Les mots de passe ne correspondent pas',
        mustBeInteger: 'La valeur doit être un entier',
        valueTooLong: 'Valeur trop longue',
        wrongPhoneNumber: 'Numéro de téléphone incorrect',
        phoneNumberAlreadyTaken: 'Numéro de téléphone déjà pris',
        emailAlreadyTaken: 'Email déjà pris',
        notFound: 'Non trouvé',
        sessionExpired: 'Session expirée',
        tenantNotFound:
            "La configuration indiquée n'existe pas. Vérifiez l'adresse du site et réessayez.",
        selectEquipmentTypeToConfigureParameters:
            "Sélectionnez le type d'équipement pour configurer les paramètres.",
        noParametersToConfigure:
            "Le type d'équipement sélectionné n'a pas de paramètres à configurer.",
        terminalAlreadyRegistered: 'Terminal déjà enregistré.',
        invalidPin: 'PIN non valide',
        eventCollision:
            "L'heure de l'événement que vous voulez ajouter chevauche l'heure d'un autre événement.",
        mustStartWithSlash: 'Doit commencer par /',
        mustBeBetween: 'La valeur doit être entre:',
        minLength: 'Longueur minimale: ',
        maxLength: 'Longueur maximale: ',
        invalidInputForCodeType:
            'Entrée non valide pour le type de code sélectionné',
        invalidCodeOrNoPermission:
            "Le code est invalide ou vous n'avez pas suffisamment de permission pour effectuer cette action.",
        endDateLowerThanStart:
            'La date de fin ne peut pas être inférieure à la date de début',
        iconAlreadyTaken: "L'icône a déjà été prise",
        notEnoughQuantityInStorage: 'Quantité insuffisante en stock.',
        valueTooLow: 'Valeur trop basse',
        valueTooHigh: 'Valeur trop élevée',
        maxAvailableQuantity: 'Nombre maximal',
        someFilesRejectedDueToSize:
            "Certains fichiers ont été rejetés en raison de leur taille. Taille maximale d'un fichier unique:",
        cameraDeviceNotFound: 'Appareil photo non trouvé',
        cameraPermissionDenied:
            "L'accès à la caméra du dispositif a été bloqué dans les paramètres du site, réinitialisez les paramètres du site et autorisez l'utilisation de la caméra.",
        passwordResetLinkExpired:
            'Le lien de réinitialisation du mot de passe a expiré',
        noInternetConnection: 'Pas de connexion Internet',
        minimum: 'Minimum',
        mustBeGreaterThan: 'Doit être supérieur à',
        noEventTypesDefined: "Aucun type d'événement défini",
        regexPatternDelimiterError:
            'Le séparateur doit être omis avec le caractère \\ Npar exemple : \\/',
        emailNotMatchPatternDefiniedInTenant:
            "L'email ne correspond pas au modèle défini dans le locataire",
        partMustHaveEntriesToCorrectQuantity:
            'La pièce doit avoir des entrées pour corriger la quantité.',
        fileTooBigToOpenWillBeDownloaded:
            'Le fichier est trop volumineux pour être ouvert, le fichier sera téléchargé sur votre appareil.',
        entriesNotSavedDueToCollision:
            "Les entrées n'ont pas été ajoutées. Des événements existent déjà à l'heure sélectionnée.",
        someEntriesWereRejected:
            "Certaines entrées n'ont pas été ajoutées car elles sont en conflit avec d'autres événements.",
        toolAlreadyInCart: 'Cet outil est déjà dans votre panier',
        toolAlreadyTaken: 'Cet outil a déjà été publié',
        toolIsNotTaken: "Cet outil n'a pas été publié",
        documentNotEditable: 'Ce document ne peut pas être modifié',
        notPermissionsToEditDocument:
            "Vous n'êtes pas autorisé à modifier ce document",
        cannotLoadDocumentNoPath:
            "Le document n'a pas pu être chargé - adresse invalide",
        locationNameNotMatchPatternDefiniedInTenant:
            'Le nom ne correspond pas à la règle définie dans les paramètres',
        noFloorLayoutProvided: "L'étage n'a pas de plan défini",
        maximum: 'Valeur maximum',
        allLanguagesRequired: 'Complétez la valeur dans toutes les langues',
        noItemsAvailable: 'Aucun article disponible',
        noFlagsConfigured: 'Aucun indicateur défini',
        noSkillsDefined: 'Aucune compétence définie',
        someoneIsWorkingOnIssue:
            "Tous les employés n'ont pas terminé leur travail sur ce rapport. Êtes-vous sûr de vouloir y mettre fin ?",
        fillAllRequiredParameters: 'Remplissez tous les paramètres requis.',
        issueLimitError:
            'La limite de numéros dans la catégorie sélectionnée pour a été atteinte : ',
        issueLimitError2: 'et fonction: ',
        duplicateError: 'Cette valeur existe déjà',
        versionErrorMessage:
            "Vos modifications récentes n'ont pas été enregistrées, car quelqu'un d'autre a effectué des modifications en même temps. Actualisez la page et réessayez.",
        firstLoginTrustedDeviceError:
            'La première connexion sur un nouvel appareil nécessite la saisie de votre adresse e-mail et de votre mot de passe.',
        tagNotFound: 'Carte/étiquette non reconnue',
        noChecklistsAssignedToControl:
            "Le contrôle sélectionné n'a pas de liste de contrôle qui lui est attribuée",
        lockerNotConnected: "Le verrou n'est pas connecté",
        lockerNotAvailable: "Le verrou n'est pas disponible",
        noChecklistItemsError: "La liste de contrôle n'est pas configurée",
    },
    navDrawer: {
        dashboard: 'Tableau de bord',
        issues: 'Problèmes',
        timetable: 'Emploi du temps',
        machines: 'Machines',
        tools: 'Outils',
        parts: 'Pièces',
        storage: 'Entrepôt',
        staff: 'Personnel',
        configuration: 'Configuration',
        notes: 'Notes',
        notifications: 'Notifications',
        profile: 'Profil',
        supervision: 'Supervision',
    },
    barcodeScanner: {
        barCode: 'Code barre',
        id: 'ID',
    },
    categoryPicker: {
        categoryPlaceholder: 'Catégorie...',
        selectCategory: 'Sélectionner une catégorie',
        noSubcategories: 'Pas de sous-catégories',
    },
    companies: {
        addCompany: 'Ajouter une entreprise',
        editCompany: "Modifier l'entreprise",
        fullName: 'Nom complet',
        shortName: 'Nom abrégé',
        group: 'Groupe',
        country: 'Pays',
        city: 'Ville',
        street: 'Rue',
        postCode: 'Code postal',
        phone: 'Téléphone',
        email: 'Email',
        website: 'Site web',
        NIP: 'NIP',
        REGON: 'Registre national des entreprises',
        active: 'Actif',
        nameRequired: 'Le nom est requis',
        shortNameRequired: 'Le nom est requis',
    },
    issues: {
        tookAt: 'Pris à',
        changeHistory: 'Historique des modifications',
        load: 'Charger',
        date: 'Date',
        createdBy: 'Créé par',
        action: 'Action',
        data: 'Données',
        created: 'Créé',
        updated: 'Mis à jour',
        deleted: 'Supprimé',
        restored: 'Restauré',
        issues: 'Problèmes',
        issue: 'Problème',
        by: 'par',
        name: 'Nom',
        applicantsDescription: 'Description du demandeur',
        accidentDescription: "Description de l'accident",
        jobDescription: "Description de l'emploi",
        jobSummary: "Résumé de l'emploi",
        category: 'Catégorie',
        status: 'Statut',
        noFlow: '[Aucun flux]',
        equipment: 'Équipement',
        criticality: 'Criticité',
        hour: 'Heure',
        formalConfirmation: 'Confirmation formelle',
        formalConfirmationShortcut: 'FC',
        formalConfirmationRequired: 'FC requise',
        parameter: 'Paramètre',
        value: 'Valeur',
        addIssue: 'Ajouter un problème',
        expectedCompletionDate: 'Date prévue de fin',
        issueDescription: 'Description du problème',
        partsUsage: 'Élimination des pièces',
        assignedEmployees: 'Employés affectés',
        requiredHelp: 'Aide requise',
        returnParts: 'Retourner la pièce',
        confirmUnassignEmployeeWhoTakenIssue:
            'Cet employé a pris le problème sélectionné. Voulez-vous le retirer?',
        responsibleUser: 'Utilisateur responsable',
        responsibleRules: 'Utilisateurs responsables - règles',
    },
    machines: {
        machines: 'Machines',
        xIssuesNotPlanned: ' (non planifié)',
        noIssues: 'Aucun problème',
    },
    maintenance: {
        maintenance: 'Maintenance',
    },
    notes: {
        notes: 'Notes',
        note: 'Note',
        title: 'Titre',
        archived: 'Archivé',
    },
    parts: {
        parts: 'Pièces',
        warehouseOutgoings: "Sorties d'entrepôt",
        fittingEquipmentTypes: "Types d'équipement appropriés",
        goToEquipmentType: "Aller au type d'équipement",
        selectPart: 'Sélectionner une pièce',
        usageReason: 'Raison',
        usageOtherReason: 'Autre',
        replacements: 'Remplacements',
        partEntry: 'Entrée de pièce',
        goToPart: 'Aller à la pièce',
        fittingMachines: 'Machines de correspondance',
    },
    costCenter: {
        costCenter: 'Centre de coûts',
    },
    equipmentTypes: {
        equipment: 'Équipement',
        newEquipmentType: "Nouveau type d'équipement",
        fittingParts: 'Pièces adaptées',
        goToParts: 'Aller aux pièces',
    },
    machinesAndToolsDefinitions: {
        machinesAndToolsDefinitions: "Définitions de machines et d'outils",
    },
    flows: {
        flow: 'Flux',
        states: 'États',
        transitions: 'Transitions',
        state: 'État',
        default: 'Par défaut',
        warning: 'Avertissement',
        problem: 'Problème',
        fixing: 'Correction',
        finished: 'Fini',
    },
    parameters: {
        categoryParameter: 'Paramètre de catégorie',
        equipmentTypeParameter: "Paramètre de type d'équipement",
    },
    staff: {
        staff: 'Personnel',
        editUserAccess: "Modifier l'accès utilisateur",
        permissionsUpdated: 'Autorisations mises à jour',
        passwordUpdated: 'Mot de passe mis à jour',
        codeUpdated: 'Code mis à jour',
        changePasswordAndCode: 'Changer le mot de passe et le code',
        goToLicenses: 'Aller aux licences',
        editAccess: "Modifier l'accès",
        editUser: "Modifier l'utilisateur",
        addUser: 'Ajouter un nouvel utilisateur',
        nameAndLastname: '@:common.USER_NAME_LABEL',
        accountStatus: 'Statut du compte',
        phoneNumber: 'Numéro de téléphone',
        department: 'Département',
        passwordChange: 'Changement de mot de passe',
        codeChange: 'Changement de code',
        newPassword: 'Nouveau mot de passe',
        confirmNewPassword: 'Confirmer le nouveau mot de passe',
        changePassword: 'Changer le mot de passe',
        newCode: 'Nouveau code',
        confirmNewCode: 'Confirmer le nouveau code',
        changeCode: 'Changer le code',
        addEntry: 'Ajouter une entrée',
        editEntry: "Modifier l'entrée",
        editLicense: 'Modifier la licence',
        addLicense: 'Ajouter une licence',
        licenseNumber: 'Numéro de licence',
        prefferedLocale: 'Langue préférée',
        oldPassword: 'Ancien mot de passe',
        newPasswordConfirmation: 'Confirmer le nouveau mot de passe',
        reading: 'Affichage',
        creating: 'Création',
        updating: 'Mise à jour',
        deleting: 'Suppression',
        importScheduleFile: 'Importer un planning depuis un fichier',
        importSchedule: {
            errors: {
                user_not_found: 'Utilisateur non trouvé [{user}]',
                user_found_many: '{count} utilisateurs trouvés [{user}]',
                event_collision: 'Collision d`événements',
                hour_cell_parse: 'Erreur d`analyse de cellule',
            },
        },
        oldCode: 'Ancien code',
        newCodeConfirmation: 'Confirmation du nouveau code',
        setAccessBasedOnProfile: "Accorder l'accès en fonction du profil",
        selectAccessMergeType: 'Choisissez comment combiner les autorisations',
        noAccessesInProfileMessage:
            "Le profil sélectionné n'a aucune autorisation. Voulez-vous quand même écraser?",
    },
    breadCrumb: {
        configuration: 'Configuration',
        locations: 'Emplacements',
        home: 'Accueil',
        machines: 'Machines',
        tools: 'Outils',
        issues: 'Problèmes',
        notes: 'Notes',
        maintenance: 'Maintenance',
        parts: 'Pièces',
        warehouse: 'Entrepôt',
        dictionary: 'Dictionnaire',
        categories: 'Catégories',
        parameters: 'Paramètres',
        costCenter: 'Centre de coût',
        flows: 'Flux',
        states: 'États',
        transitions: 'Transitions',
        shiftSchemas: 'Schémas de postes',
        shifts: 'Postes',
        definitionsOfMachinesAndToolsTypes:
            "Définitions des types de machines et d'outils",
        add: 'Ajouter',
        edit: 'Modifier',
        staff: 'Personnel',
        licenses: 'Licences',
        entries: 'Entrées',
        companiesDatabase: 'Base de données des entreprises',
        companyManagement: "Gestion d'entreprise",
        companyData: "Données de l'entreprise",
        supportedLanguages: 'Langues prises en charge',
        en: 'Anglais',
        pl: 'Polonais',
        es: 'Espagnol',
        de: 'Allemand',
        it: 'Italien',
        fr: 'Français',
        ru: 'Russe',
        uk: 'Ukrainien',
        pt: 'Portugais',
        defaultLanguage: 'Langue par défaut',
        notifications: 'Notifications',
        notificationsManagement: 'Gestion des notifications',
        myProfile: 'Mon profil',
    },
    attributeTypes: {
        text: 'Texte',
        note: 'Note',
        integer: 'Entier',
        decimal: 'Décimal',
        date: 'Date',
        time: 'Heure',
        dateTime: 'Date et heure',
        color: 'Couleur',
        icon: 'Icône',
        boolean: 'Oui/Non',
    },
    costCalculator: {
        costCalculator: 'Calculateur de coût',
        waitTime: "Temps d'attente",
        serviceTime: 'Temps de service',
        suspendTime: 'Temps de suspension',
        totalTime: 'Temps total',
        estimatedCost: 'Coût estimé',
        calculate: 'Calculer',
        withoutParts: 'Sans pièces',
        timeOfReportingIssue: 'Heure de déclaration du problème',
        timeOfServiceStart: 'Heure de début du service',
        timeOfReportingEnd: 'Heure de fin du service',
        days: 'Jours',
        hours: 'Heures',
        minutes: 'Minutes',
        enterNewTime: 'Entrer un nouveau temps',
        fromIssueReportToServiceStart:
            'Temps entre la déclaration du problème et le début du service',
        fromServiceStartToServiceEnd:
            'Temps entre le début et la fin du service',
        workTime: 'Temps de travail',
        includeAwaitingTime: "Inclure le temps d'attente",
    },
    dashboard: {
        components: {
            myIssues: {
                title: 'Mes problèmes',
                assignedToMe: 'Assigné à moi',
                assignedToGroup: 'Assigné à mon groupe',
                tookByMe: 'Prise par moi',
                takeIssueBtn: 'Prendre',
                arriveIssueBtn: 'Je suis arrivé',
                finishIssueBtn: 'Terminer',
                history: 'Historique',
                myResponsible: 'Je suis responsable de',
            },
        },
    },
    synchronization: {
        enabled: 'Activé',
        hasHeaders: 'A des en-têtes',
        leaveFile: 'Laisser le fichier',
        host: 'Hôte',
        port: 'Port',
        protocol: 'Protocole',
        username: "Nom d'utilisateur",
        password: 'Mot de passe',
        root: 'Racine',
        encoding: 'Encodage',
        separator: 'Séparateur',
        externalSystemId: 'ID système externe',
        cronExpression: 'Expression cron',
        appendFullStock: 'Ajouter le stock complet',
        includeHeaders: 'Inclure les en-têtes',
        withTrashed: 'Avec les données supprimées',
        filePattern: 'Modèle de fichier',
    },
    processes: {
        created_at: 'Créé à',
        started_at: 'Commencé à',
        updated_at: 'Mis à jour à',
        finished_at: 'Terminé à',
        attempts: 'Tentatives',
        queue: "File d'attente",
        job_id: 'ID de travail',
        job_uuid: 'UUID de travail',
        progress_max: 'Progression max',
        progress_now: 'Progression maintenant',
        outputMessage: 'Message de sortie',
        status: {
            queued: "en file d'attente",
            executing: "en cours d'exécution",
            finished: 'terminé',
            failed: 'échoué',
            retrying: 'en train de réessayer',
            undefined: 'non défini',
        },
    },
    weekDays: {
        mo: 'Lundi',
        tu: 'Mardi',
        we: 'Mercredi',
        th: 'Jeudi',
        fr: 'Vendredi',
        sa: 'Samedi',
        su: 'Dimanche',
    },
    reports: {
        reports: 'Rapports',
        dateFrom: 'De la date',
        dateTo: 'À la date',
        types: {
            operation_sheet: 'Feuille de calcul',
            issue_summary: 'Résumé du problème',
            grouped_summary: 'Rapport sommaire',
            storage_operations: "Opérations d'entrepôt",
            part_quantity_export: 'Quantité de pièces',
        },
        reportFor: 'Rapport pour',
        includeQuantityLeft0: 'Inclure les pièces avec une quantité nulle',
    },
    logs: {
        issues: {
            escalation: 'Escalade ({minutes} min) - notification envoyée',
        },
        issueEmployee: {
            assignedAt: 'Employé assigné :',
            receivedAt: 'Employé a reçu :',
            tookAt: 'Employé a pris :',
            finishedAt: 'Employé a terminé :',
            deletedAt: 'Employé supprimé de la déclaration',
        },
    },
    units: {
        no: 'Pièce',
        st: 'Ensemble',
    },
    rrule: {
        frequency: 'Fréquence',
        dtstart: 'Date de début',
        tzid: 'Fuseau horaire',
        until: "Jusqu'à",
        count: 'Compter',
        interval: 'Intervalle',
        wkst: 'Commence jour',
        byweekday: 'En semaine',
        bymonth: 'Par mois',
        yearly: 'Annuel',
        monthly: 'Mensuel',
        weekly: 'Hebdomadaire',
        daily: 'Quotidien',
        hourly: 'Horaire',
        minutely: 'Minutieusement',
        secondly: 'Deuxièmement',
        infinitePeriodicityMessage:
            'La périodicité est infinie, du fait des performances, seules 500 lignes sont affichées',
    },
    months: {
        jan: 'Janvier',
        feb: 'Février',
        mar: 'Mars',
        apr: 'Avril',
        may: 'Peut',
        jun: 'Juin',
        jul: 'Juillet',
        aug: 'Août',
        sep: 'Septembre',
        oct: 'Octobre',
        nov: 'Novembre',
        dec: 'Décembre',
    },
    charts: {
        charts: 'Graphiques',
        count: 'Nombre de problèmes',
        total: 'Temps total des problèmes (du rapport à la fin)',
        serw: 'Temps total de réparation (Ttotal - Twait)',
        mttr1: 'Délai moyen du rapport à la fin',
        mttr2: 'Temps moyen de la prise à la fin',
        mtbf: 'Temps de disponibilité moyen entre les problèmes',
        mttf: "Temps moyen jusqu'à l'échec",
    },
    accessMergeValues: {
        sum: 'Somme',
        product: 'Produit',
        overwrite: 'écraser',
    },
    tpm: {
        history: 'Histoire',
        standardObstacle: 'Obstacle standard',
        customObstacle: 'Obstacle personnalisé',
        bhp: 'Sécurité et santé au travail',
        returnToMainPage: 'Retour à la page principale',
        bhpMessage:
            "Si vous constatez des risques pour la sécurité, veuillez les signaler immédiatement à votre supérieur hiérarchique et utiliser le formulaire de signalement situé sous le tableau d'affichage.",
        ok: 'OK',
        send: 'Envoyer',
        description: 'Description',
        title: 'Titre',
        realization: 'Réalisation',
        answer: 'Réponse',
        pendingSurveys: 'Enquêtes en cours',
        surveys: 'Enquêtes',
        systemSurvey: 'Enquête système',
        addPage: 'Ajouter une page',
        createSurvey: 'Créer une enquête',
        addSection: 'Ajouter une section',
        addQuestion: 'Ajouter une question',
        questionContent: 'Contenu de la question',
        answerOption: 'Option de réponse',
        addQuestionAnswer: 'Ajouter une option de réponse',
        surveyName: "Nom de l'enquête",
        sectionName: 'Nom de la section',
        noSurveyAnswers: 'Aucune réponse',
        removeSection: 'Supprimer la section',
        published: 'Publiée',
        unpublished: 'Non publiée',
        pendingPublication: 'Modifications en attente de publication',
        removeQuestion: 'Supprimer la question',
        removeAnswer: "Supprimer l'option de réponse",
        publish: 'Publier',
        unpublish: 'Dépublier',
        previewResults: 'Voir les résultats',
        supervisior: 'Superviseur',
        surveyResults: "Résultats de l'enquête",
        surveysEvents: 'Configuration des événements - enquêtes',
        operatedBy: 'Opéré par',
        confirmReadInformations: "J'ai pris connaissance des informations",
        noticeContent: "Contenu de l'avis",
        notice: 'Avis',
        surveyEventName: "Nom de l'événement",
        survey: 'Enquête',
        newIssue: 'Nouveau rapport',
        surveyEventConfigurationAlreadyExists:
            'Une telle configuration existe déjà',
        lastComment: 'Dernier commentaire de la personne responsable',
        surveyNotConfigured: 'Enquête non configurée',
        fillSurvey: "Remplir l'enquête",
        singleSurveyEntries: 'résultats uniques',
        groupedSurveyEntries: 'Résultats groupés',
        publicationId: 'Identifiant de publication',
        publicationDate: 'Date de publication',
        versionId: 'ID de version',
        answersCount: 'Nombre de réponses',
        answers: 'Réponses',
        withoutSupervisor: 'Pas de superviseur',
        defaultSupervisor: 'Superviseur par défaut',
        flowStateFlags: "Indicateurs d'état",
        qrActionsSettings: "Paramètres d'action du code QR",
        loginRequired: 'Nécessite une connexion',
        questionContext: 'Le contexte de la question',
        currentSurveyVersionPreview:
            "Aperçu de la version actuelle de l'enquête",
        surveyDescription: "Description de l'enquête",
        sectionDescription: 'Description de la rubrique',
        instructions: 'Instructions',
        instruction: 'Instruction',
        instructionRevisions: 'Révisions',
        instructionRevision: 'Révision',
        checklists: 'Listes de contrôle',
        checklist: 'Liste de contrôle',
        checklistItem: 'Élément de liste',
        manageChecklistFields: 'Gérer les éléments de la liste',
        checklistItemDisplayOptions: 'Éléments affichés',
        revisionAutoRejectedInfo: '[Système] Rejeté - nouvelle révision créée',
    },
    checklists: {
        itemBasic: 'Élément basique',
        itemSeparator: 'Séparateur',
        itemSection: 'Section',
        publish: 'Publier',
        previewCurrentVersion: 'Aperçu de la version actuelle',
    },
};
